import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COL_AGGREGATE_DATA} from '../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../utils/capitalize";
import formatNumber from "../../utils/formatNumber";
import {getMembershipReport, sync} from "../../api/app";
import 'react-quill/dist/quill.snow.css';
import {membershipQuery} from "../../query/aggregation";
import {useDispatch, useSelector} from "react-redux";
import exportToExcel from "../../utils/exporter";
import generateChar from "../../utils/generateChar";

let filter = {};
let selectedSources = [];
let allMode = false;

let total = 0;
const CHUNK_SIZE = 5000;

const searchableFields = [
    { field: 'first_name', isNumeric: false },
    // { field: 'last_name', isNumeric: false },
    // { field: 'full_name', isNumeric: false },
    // { field: 'contact_number', isNumeric: false },
    // { field: 'agent.name', isNumeric: true },
    // { field: 'agent.username', isNumeric: true },
    { field: 'id_number', isNumeric: false }
];

const support_level = ['General', 'Strong Support HH', 'Support HH', 'Undecided', 'Do not support', 'Strongly do not Support HH', 'Will not say', 'Will not vote'];

const Membership = () => {

    document.title = "Membership";

    const token = localStorage.getItem('jwtToken');
    const [reset, setReset] = useState(new Date().getTime());
    const auth = useSelector((state) => state.auth.user);
    const [provincialSelected, setProvincialSelected] = useState(null);
    const [districtSelected, setDistrictSelected] = useState(null);
    const [constituencySelected, setConstituencySelected] = useState(null);
    const [wardSelected, setWardSelected] = useState(null);
    const [pollingSelected, setPollingSelected] = useState(null);
    const [exportLoading, setExportLoading] = React.useState(false);
    const [exportProgress, setExportProgress] = React.useState(0); // 0..100
    const [exportCounts, setExportCounts] = React.useState({ done: 0, total: 0 });
    const [stateReady, setStateReady] = React.useState(false);

    const {province, districts, constituencies, wards, polling_stations} = useSelector(state => state.app?.administrative);

    const dispatch = useDispatch();

    useEffect(() => {
        getMembershipReport().then((response) => {
            if(!response.error) {
                $('#total-users').text(formatNumber(response.payload.total, "digit"));
                $('#date-current').text(response.payload.date_current);
                $('#month-current').text(response.payload.month_current);
                $('#daily-active').text(formatNumber(response.payload.daily, "digit"));
                $('#monthly-active').text(formatNumber(response.payload.monthly, "digit"));
                $('#total-gender').text(`Male: ${formatNumber(response.payload.total_male, "digit")} --- Female: ${formatNumber(response.payload.total_female, "digit")}`);
            }
        });
    }, [reset]);

    useEffect(() => {
        dispatch(sync());
    }, []);

    useEffect(() => {
        let table = $('#membership').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Membership Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                const searchTerm = ($('.dataTables_filter input').val() || '').trim();

                const baseFilter = {
                    $match: filter
                };

                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: searchTerm,
                        collection: "membership",
                        filter: membershipQuery(data.start, data.length, baseFilter, searchTerm, searchableFields)
                    }),
                    success: function (res) {
                        let array = [];
                        res.data[0].results.map((data) => {
                            array.push({raw: data})
                        });

                        total = res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0;

                        callback({
                            recordsTotal: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            recordsFiltered: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return capitalize(`${data.first_name} ${data.last_name}`);
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.id_number;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.gender === "n/a" ? "N/A" : capitalize(data.gender);
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return data.category === "n/a" ? "N/A" : capitalize(data.category);
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY HH:mm");
                    },
                    "targets": 5
                }
            ]
        });

        $('#membership tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        const badge = (data = []) => {
            if(!Array.isArray(data)) return "";
            const badges = {
                kwenyu : `<span class="badge badge-danger tx-white mr-2">Kwenyu</span>`,
                fisp   : `<span class="badge badge-info tx-white mr-2">FISP</span>`,
                health   : `<span class="badge badge-warning tx-dark mr-2">Health</span>`,
                napsa  : `<span class="badge badge-success tx-white mr-2">NAPSA</span>`,
                c4w    : `<span class="badge badge-secondary tx-white mr-2">Cash For Work</span>`,
                sct    : `<span class="badge badge-primary tx-white mr-2">Social Cash Transfer</span>`
            };

            return data.map(item => badges[item] || "").join("");
        };

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Age Group:</td>' +
                '<td class="text-capitalize">' +
                `${d?.raw.age_group || "Unassigned"}` +
                '<tr>' +
                '<td>Contact Number:</td>' +
                '<td>' +
                `${d?.raw.contact_number || "Unassigned"}` +
                '<tr>' +
                '<td>Source:</td>' +
                '<td class="text-capitalize tx-danger">' +
                badge(d?.raw.source) +
                '</td>' +
                '<tr>' +
                '<td>Category:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.category +
                '<tr>' +
                '<td>Polling Station:</td>' +
                '<td>' +
                `${d?.raw.polling_station?.name || "Unassigned"}` +
                '<tr>' +
                '<td>Ward:</td>' +
                '<td>' +
                `${d?.raw.admin_level?.ward?.name || "Unassigned"}` +
                '<tr>' +
                '<td>Constituency:</td>' +
                '<td>' +
                `${d?.raw.admin_level?.constituency?.name || "Unassigned"}` +
                '<tr>' +
                '<td>District:</td>' +
                '<td>' +
                `${d?.raw.admin_level?.district?.name || "Unassigned"}` +
                '<tr>' +
                '<td>Province:</td>' +
                '<td>' +
                `${d?.raw.admin_level.provincial.name || "Unassigned"}` +
                '<tr>' +
                '<tr>' +
                '<td>Registered Voter Card:</td>' +
                '<td>' +
                `${d?.raw?.voter_card ? capitalize(d?.raw.voter_card) : "Unassigned"}` +
                '<tr>' +
                '<tr>' +
                '<td>Support Level:</td>' +
                '<td>' +
                `${d?.raw?.support_level ? capitalize(d?.raw.support_level) : "Unassigned"}` +
                '<tr>' +
                '<td>Documents:</td>' +
                '<td class="text-capitalize">' +
                `${d?.raw?.documents?.length > 0 ? `<nav class="nav nav-icon-only"><a target="_blank" href=${d?.raw?.documents[0]?.uri} class="nav-link edit_user"><i class="fa fa-eye"></i> View Voter Card</a></nav>` : "No document"}` +
                '<tr>' +
                '<tr>' +
                '<td>Action:</td>' +
                '<td class="text-capitalize">' +
                '<nav class="nav nav-icon-only"><a target="_blank" href="#" class="nav-link enroll_agent"><i class="fa fa-pencil"></i> Enroll Agent</a></nav>'+
                '<tr>' +
                '<td>Added By:</td>' +
                '<td class="text-capitalize text-primary">' +
                d?.raw.agent.name +
                '</table>'
            );
        }

        table.on('click', '.enroll_agent', function(e) {
            e.preventDefault();

            $('#agent_form').parsley();

            let extract_td = table.row($(this).closest('tr')).data();
            let name = $("#name");
            let username = $("#username");

            console.log(extract_td);

            // name.val(`${extract_td.raw.first_name} ${extract_td.raw.last_name}`);

            $("#password").prop('required', true);
            initialize();
            $("#modalAgent").modal("show");
        });

        return () => {
            table.destroy();
            filter = {};
        }
    }, []);

    const initialize = () => {
        $('#province').select2({
            placeholder: 'Select Provinces',
            multiple: true,
            width: '100%',
            data: province.map(p => ({ id: p._id, text: capitalize(p.name) }))
        });

        $('#constituency, #ward, #polling_station').select2({
            placeholder: 'Select...',
            multiple: true,
            width: '100%'
        });

        // Province → Constituency
        $('#province').on('change', function () {
            const selectedProvinces = $(this).val() || [];
            const filteredConstituencies = constituencies.filter(c =>
                selectedProvinces.includes(c.administrative)
            );

            $('#constituency').empty().select2({
                placeholder: 'Select Constituencies',
                multiple: true,
                width: '100%',
                data: filteredConstituencies.map(c => ({
                    id: c._id,
                    text: capitalize(c.name)
                }))
            }).val(null).trigger('change');

            $('#ward, #polling_station').val(null).trigger('change').empty();
        });

        // Constituency → Ward
        $('#constituency').on('change', function () {
            const selectedConstituencies = $(this).val() || [];
            const filteredWards = wards.filter(w =>
                selectedConstituencies.includes(w.constituency)
            );

            $('#ward').empty().select2({
                placeholder: 'Select Wards',
                multiple: true,
                width: '100%',
                data: filteredWards.map(w => ({
                    id: w._id,
                    text: capitalize(w.name)
                }))
            }).val(null).trigger('change');

            $('#polling_station').val(null).trigger('change').empty();
        });

        // Ward → Polling Station
        $('#ward').on('change', function () {
            const selectedWards = $(this).val() || [];
            const filteredPollings = polling_stations.filter(p =>
                selectedWards.includes(p.ward)
            );

            $('#polling_station').empty().select2({
                placeholder: 'Select Polling Stations',
                multiple: true,
                width: '100%',
                data: filteredPollings.map(p => ({
                    id: p._id,
                    text: capitalize(p.name)
                }))
            }).val(null).trigger('change');
        });
    }

    const onAreaSelected = (data) => {
        const id = data?._id || null;
        const name = data?.name || "All Provinces";

        filter = id ? { "admin_level.provincial": id } : {};

        $("#provincial-name").text(name);
        setProvincialSelected(id);

        $("#district-name").text("District");
        setConstituencySelected(null);

        $("#constituency-name").text("Constituency");
        setConstituencySelected(null);

        $("#ward-name").text("Ward");
        setWardSelected(null);

        $("#polling-name").text("Polling Station");
        setPollingSelected(null);

        handleSupportSelect("General");
        $('#membership').DataTable().ajax.reload();
    };

    const onDistrictSelected = (data) => {
        filter = {"admin_level.district": data._id};

        $("#district-name").text(data.name);
        setDistrictSelected(data._id);

        $("#constituency-name").text("Constituency");
        setConstituencySelected(null);

        $("#ward-name").text("Ward");
        setWardSelected(null);

        $("#polling-name").text("Polling Station");
        setPollingSelected(null);

        handleSupportSelect("General");
        $('#membership').DataTable().ajax.reload();
    }

    const onConstituencySelected = (data) => {
        filter = {"admin_level.constituency": data._id};
        $("#constituency-name").text(data.name);
        setConstituencySelected(data._id);

        $("#ward-name").text("Ward");
        setWardSelected(null);

        $("#polling-name").text("Polling Station");
        setPollingSelected(null);

        handleSupportSelect("General");
        $('#membership').DataTable().ajax.reload();
    }

    const onWardSelected = (data) => {
        filter = {"admin_level.ward": data._id};
        $("#ward-name").text(data.name);

        setWardSelected(data._id);

        $("#polling-name").text("Polling Station");
        setPollingSelected(null);

        handleSupportSelect("General");
        $('#membership').DataTable().ajax.reload();
    }

    const onPollingSelected = (data) => {
        filter = {"polling_station": data._id};
        $("#polling-name").text(data.name);

        setPollingSelected(data._id);
        handleSupportSelect("General");
        $('#membership').DataTable().ajax.reload();
    }

    const aggRequest = (start, limit) => {
        return new Promise((resolve, reject) => {
            const baseFilter = { $match: filter };

            $.ajax(GET_COL_AGGREGATE_DATA, {
                type: 'POST',
                headers: { "Authorization": token },
                contentType: 'application/json',
                data: JSON.stringify({
                    query: '',
                    collection: "membership",
                    filter: membershipQuery(start, limit, baseFilter, '', searchableFields)
                }),
                success: resolve,
                error: reject
            });
        });
    }

    const exportData = async () => {
        try {
            setExportLoading(true);
            setExportProgress(0);
            setExportCounts({ done: 0, total: 0 });

            let offset = 0;
            const allRows = [];

            // If you maintain a global "total", prefer it; else we’ll derive from first batch.
            let grandTotal = (typeof total === 'number' && total > 0) ? total : null;

            // First batch
            const firstRes = await aggRequest(offset, CHUNK_SIZE);
            const firstFacet = firstRes.data[0] || {};
            const firstRows = firstFacet.results || [];

            if (!grandTotal) {
                grandTotal = (firstFacet.totalCount && firstFacet.totalCount[0]?.total) || firstRows.length || 0;
            }

            allRows.push(
                ...firstRows.map(item => ({
                    name: capitalize(`${item.first_name || ''} ${item.last_name || ''}`.trim()),
                    id_number: item?.id_number,
                    gender: capitalize(item?.gender),
                    category: capitalize(item?.category),
                    age_group: item?.age_group,
                    contact_number: item?.contact_number,
                    polling_station: item?.polling_station?.name,
                    ward: item?.admin_level?.ward?.name,
                    constituency: item?.admin_level?.constituency?.name,
                    provincial: item?.admin_level?.provincial?.name,
                    agent: item?.agent?.name
                }))
            );

            offset += firstRows.length;

            // progress after first batch
            const pct1 = grandTotal > 0 ? Math.min(100, Math.round((offset / grandTotal) * 100)) : 0;
            setExportProgress(pct1);
            setExportCounts({ done: offset, total: grandTotal });

            // Remaining batches
            while (grandTotal > 0 && offset < grandTotal) {
                const res = await aggRequest(offset, CHUNK_SIZE);
                const doc = res.data[0] || {};
                const rows = doc.results || [];
                if (!rows.length) break;

                allRows.push(
                    ...rows.map(item => ({
                        name: capitalize(`${item.first_name || ''} ${item.last_name || ''}`.trim()),
                        id_number: item?.id_number,
                        gender: capitalize(item?.gender),
                        category: capitalize(item?.category),
                        age_group: item?.age_group,
                        contact_number: item?.contact_number,
                        polling_station: item?.polling_station?.name,
                        ward: item?.admin_level?.ward?.name,
                        constituency: item?.admin_level?.constituency?.name,
                        provincial: item?.admin_level?.provincial?.name,
                        agent: item?.agent?.name
                    }))
                );

                offset += rows.length;

                // update progress
                const pct = Math.min(100, Math.round((offset / grandTotal) * 100));
                setExportProgress(pct);
                setExportCounts({ done: offset, total: grandTotal });

                // optional tiny delay to keep UI responsive
                // await new Promise(r => setTimeout(r, 15));
            }

            const headers = [
                "Name","ID Number","Gender","Category","Age Group",
                "Contact Number","Polling Station","Ward","Constituency","Province","Agent"
            ];

            exportToExcel(headers, allRows, "Membership");
            setExportLoading(false);
            setExportProgress(100);
            setExportCounts({ done: grandTotal, total: grandTotal });
        } catch (err) {
            setExportLoading(false);
            cogoToast.error(
                err?.responseJSON?.error?.details?.[0]?.message ?? err?.responseJSON?.error ?? 'Export failed',
                { position: "top-right", hideAfter: 5 }
            );
        }
    };

    const handleSupportSelect = (data) => {
        const supportLevel = $("#tx-support-level");
        const dt_membership = $('#membership');
        if(data === "General") {
            supportLevel.text("Select Support Level");
            if (filter.hasOwnProperty("support_level")) {
                delete filter.support_level;
                dt_membership.DataTable().ajax.reload();
            }
            return false;
        }

        filter = Object.assign(filter, {support_level: data});
        supportLevel.text(data);
        dt_membership.DataTable().ajax.reload();
    }

    const handleFilterSelect = (value, name) => {
        filter = Object.assign(filter, {
            "voter_card": value === "registered" ? value : "n/a"
        });

        $("#tx-filter-level").text(name);
        $('#membership').DataTable().ajax.reload();
    }

    const handleDataSearch = () => {

        let selectedSources = [];

        if ($("#b1a").is(":checked")) selectedSources.push("kwenyu");
        if ($("#b2a").is(":checked")) selectedSources.push("health");
        if ($("#b3a").is(":checked")) selectedSources.push("sct");
        if ($("#b4a").is(":checked")) selectedSources.push("c4w");
        if ($("#b5a").is(":checked")) selectedSources.push("fisp");
        if ($("#b7a").is(":checked")) selectedSources.push("napsa");

        const allChecked = $("#b6a").is(":checked");

        // ---- MULTI DATA SOURCE LOGIC ----
        if (allChecked) {
            if (selectedSources.length < 2) {
                $("#b6a").prop("checked", false);
                cogoToast.error(
                    "Please select at least two sources to use Multi Data Source.",
                    { position: "top-right", hideAfter: 5 }
                );
                return;
            }

            filter.source = { $all: selectedSources };
        } else {
            if (selectedSources.length === 0) {
                delete filter.source;
            } else {
                filter.source = { $in: selectedSources };
            }
        }

        $('#dropdownDataMenuButton').dropdown('toggle');
        // ---- QUERY ONLY HERE ----
        $('#membership').DataTable().ajax.reload();
    };

    const handleSubmit = () => {

    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        $('#province, #constituency, #ward, #polling_station')
            .val(null)
            .trigger('change')
            .empty();
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Membership</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Membership</h4>
                    </div>
                    <div className="d-none d-md-block">
                        {auth.user.email === "sukohabindalungu@gmail.com" ? null : exportLoading ? <button disabled className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"></span> Exporting {exportProgress}%</button> : <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" onClick={exportData}><i className="wd-10 mg-r-5 fa fa-upload"></i> Export</button>}
                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-primary btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="provincial-name">All Provinces</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    <a href="#" onClick={(e) => {e.preventDefault(); onAreaSelected(null)}} className="dropdown-item">All Provinces</a>
                                    {province?.map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onAreaSelected(item)}} className="dropdown-item text-capitalize">{item.name}</a>
                                        )
                                    })}
                                </div>
                            </span>

                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-info btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="district-name">District</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    {provincialSelected ? districts?.filter((item) => item.administrative === provincialSelected).map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onDistrictSelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>
                                        )
                                    }) : <span className="dropdown-item">Select Province First</span>}
                                </div>
                            </span>

                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-secondary btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="constituency-name">Constituency</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    {districtSelected ? constituencies?.filter((item) => item.district === districtSelected).map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onConstituencySelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>
                                        )
                                    }) : <span className="dropdown-item">Select District First</span>}
                                </div>
                            </span>

                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-danger btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="ward-name">Ward</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    {constituencySelected ? wards?.filter((item) => item.constituency === constituencySelected).map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onWardSelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>
                                        )
                                    }) : <span className="dropdown-item">Select Constituency First</span>}
                                </div>
                            </span>

                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-facebook btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="polling-name">Polling Station</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    {wardSelected ? polling_stations?.filter((item) => item.ward === wardSelected).map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onPollingSelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>
                                        )
                                    }) : <span className="dropdown-item">Select Ward First</span>}
                                </div>
                            </span>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-4">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total
                                Registered Users</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-users" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">-</h3>
                            </div>
                            <span id="total-gender" className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Registered
                                Users Today</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="daily-active" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="date-current" className="tx-11 tx-color-02 mg-b-0 mg-t-5">-</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Registered
                                Users Monthly</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="monthly-active" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="month-current" className="tx-11 tx-color-02 mg-b-0 mg-t-5">-</span>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Membership List</h6>
                                <div className="d-flex tx-18 align-items-center">
                                    <div className="dropdown mr-2">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownDataMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-data-source">Data Source</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownSelectButton" onClick={(e) => e.stopPropagation()}>
                                            <div className="wd-200 pd-15">
                                                <div className="custom-control custom-checkbox">
                                                    <input className="custom-control-input" type="checkbox"
                                                           name="_form[]" id="b1a"/>
                                                    <label className="custom-control-label" htmlFor="b1a">Kwenyu</label>
                                                </div>

                                                <div className="custom-control custom-checkbox">
                                                    <input className="custom-control-input" type="checkbox"
                                                           name="_form[]" id="b2a"/>
                                                    <label className="custom-control-label" htmlFor="b2a">Health</label>
                                                </div>

                                                <div className="custom-control custom-checkbox">
                                                    <input className="custom-control-input" type="checkbox"
                                                           name="_form[]" id="b3a"/>
                                                    <label className="custom-control-label" htmlFor="b3a">Social Cash
                                                        Transfer</label>
                                                </div>

                                                <div className="custom-control custom-checkbox">
                                                    <input className="custom-control-input" type="checkbox"
                                                           name="_form[]" id="b4a"/>
                                                    <label className="custom-control-label" htmlFor="b4a">Cash 4
                                                        Work</label>
                                                </div>

                                                <div className="custom-control custom-checkbox">
                                                    <input className="custom-control-input" type="checkbox"
                                                           name="_form[]" id="b5a"/>
                                                    <label className="custom-control-label" htmlFor="b5a">FISP</label>
                                                </div>

                                                <div className="custom-control custom-checkbox">
                                                    <input className="custom-control-input" type="checkbox"
                                                           name="_form[]" id="b7a"/>
                                                    <label className="custom-control-label" htmlFor="b7a">NAPSA</label>
                                                </div>

                                                <div className="dropdown-divider mt-3 mb-3"></div>

                                                <div className="custom-control custom-checkbox">
                                                    <input className="custom-control-input" type="checkbox"
                                                           name="_form[]" id="b6a"/>
                                                    <label className="custom-control-label" htmlFor="b6a">Multi Data Source</label>
                                                </div>

                                                <button className="btn btn-primary btn-block mt-3" onClick={handleDataSearch}>Search</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dropdown mr-2">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-filter-level">Filter By</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownSelectButton">
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "n/a", "Registration")}>Registration</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "registered", "Voter Card")}>Voter Card</a>
                                        </div>
                                    </div>
                                    <div className="dropdown">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-support-level">Select Support Level</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            {support_level.map((item, index) => (
                                                <a className="dropdown-item" href="javascript:void(0)" key={index} onClick={handleSupportSelect.bind(null, item)}>{item}</a>
                                            ))}
                                        </div>
                                    </div>

                                    <a href="#" onClick={(e) => {
                                        setReset(new Date().getTime());
                                        e.preventDefault();
                                        $('#membership').DataTable().ajax.reload()
                                    }} className="link-03 lh-0 ml-2"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="membership" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">ID Number</th>
                                        <th className="wd-20p">Gender</th>
                                        <th className="wd-20p">Category</th>
                                        <th className="wd-20p">Date</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalAgent" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalAgent", "agent_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Create Agent</h4><p className="tx-13 tx-color-02 mg-b-0">Create agent to have access to the console</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="agent_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                        <div id="nameWrapper" className="form-group parsley-input">
                                            <label>Full Name<span className="tx-danger">*</span></label>
                                            <input id="name" type="text" className="form-control"
                                                   placeholder="Enter full name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nameWrapper" required/>
                                        </div>

                                        <div id="usernameWrapper" className="form-group parsley-input">
                                            <div className="d-flex justify-content-between">
                                                <label>Username<span className="tx-danger">*</span></label>
                                                <a href="javascript:void(0)" onClick={() => $("#username").val(generateChar(7))} className="link-01">Generate</a>
                                            </div>
                                            <input id="username" type="text" className="form-control"
                                                   placeholder="Enter username"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#usernameWrapper" required/>
                                        </div>

                                        <div id="contactWrapper" className="form-group parsley-input">
                                            <label>Contact Number<span className="tx-danger">*</span></label>
                                            <input id="contact-number" type="text" className="form-control"
                                                   placeholder="Enter contact number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#contactWrapper" required/>
                                        </div>

                                        <div id="nrcWrapper" className="form-group parsley-input">
                                            <label>NRC Number<span className="tx-danger">*</span></label>
                                            <input id="id-number" type="text" className="form-control"
                                                   placeholder="Enter NRC Number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nrcWrapper"
                                                   required
                                            />
                                        </div>

                                        <div id="roleWrapper" className="form-group parsley-input">
                                            <label>Position<span className="tx-danger">*</span></label>
                                            <select className="custom-select" id="position" required>
                                                <option value="" disabled selected>Select Position</option>
                                                <option value="provincial coordinator">Provincial Coordinator</option>
                                                <option value="constituency coordinator">Constituency Coordinator</option>
                                                <option value="ward coordinator">Ward Coordinator</option>
                                                <option value="polling station coordinator">Polling Station Coordinator</option>
                                            </select>
                                        </div>

                                        <div id="provinceWrapper" className="form-group parsley-input">
                                            <label>Province</label>
                                            <select id="province"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#provinceWrapper"
                                                    data-parsley-errors-container="#provinceWrapper"
                                                    className="custom-select"
                                            >
                                            </select>
                                        </div>

                                        <div id="constituencyWrapper" className="form-group parsley-input">
                                            <label>Constituency</label>
                                            <select id="constituency"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#constituencyWrapper"
                                                    data-parsley-errors-container="#constituencyWrapper"
                                                    className="custom-select"
                                            ></select>
                                        </div>

                                        <div id="wardWrapper" className="form-group parsley-input">
                                            <label>Ward</label>
                                            <select id="ward"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#wardWrapper"
                                                    data-parsley-errors-container="#wardWrapper"
                                                    className="custom-select"
                                            ></select>
                                        </div>

                                        <div id="pollingStationWrapper" className="form-group parsley-input">
                                            <label>Polling Station</label>
                                            <select id="polling_station"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#pollingStationWrapper"
                                                    data-parsley-errors-container="#pollingStationWrapper"
                                                    className="custom-select"
                                            ></select>
                                        </div>

                                        <div id="passwordWrapper" className="form-group parsley-input">
                                            <div className="d-flex justify-content-between">
                                                <label>Password<span className="tx-danger">*</span></label>
                                                <a href="javascript:void(0)" onClick={() => $("#password").val(generateChar(7))} className="link-01">Generate</a>
                                            </div>
                                            <input id="password" type="text" className="form-control"
                                                   placeholder="Enter new password"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#passwordWrapper"/>
                                        </div>

                                        <div className="form-group">
                                            <div data-label="Access Privilege" className="df-example mg-b-5">
                                                <div id="cbWrapper2" className="parsley-checkbox pos-relative">
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox" name="_form[]"
                                                               data-parsley-class-handler="#cbWrapper2"
                                                               data-parsley-errors-container="#cbErrorContainer2"
                                                               data-parsley-multiple="_form" id="b1a"/>
                                                        <label className="custom-control-label" htmlFor="b1a">View Statistic</label>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="b2a"/>
                                                        <label className="custom-control-label" htmlFor="b2a">Manage Agent</label>
                                                    </div>

                                                    <div id="cbErrorContainer2" className="wd-100p pos-absolute b-0 l-0"/>
                                                </div>
                                            </div>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary btn-block">Create Account</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Membership;
